import { useEffect, useState } from "react";

function App2() {
  const [step, setStep] = useState(1)
  const [nbrParticipants, setNbrParticipants] = useState(2)
  const [nbrEnTournee, setNbrEnTournee] = useState(1)
  const [nomsParticipants, setNomsParticipants] = useState([])
  const [nomsTournees, setNomsTournees] = useState([])

  return (
    <div 
      className="container py-5"
      style={{
        padding:'20px',
        fontFamily:'Arial'
      }}
    >
      <h1 className="mb-4 text-center">Secret Tournée</h1>

      {step === 1 && (
        <Step1 
          setStep={setStep} 
          setNbrParticipants={setNbrParticipants}
          setNbrEnTournee={setNbrEnTournee}
          nbrParticipants={nbrParticipants}
          nbrEnTournee={nbrEnTournee}
        />
      )}
      {step === 2 && (
        <Step2
          setStep={setStep}
          nbrParticipants={nbrParticipants}
          nbrEnTournee={nbrEnTournee}
          setNomsParticipants={setNomsParticipants}
          setNomsTournees={setNomsTournees}
          nomsParticipants={nomsParticipants}
          nomsTournees={nomsTournees}
        />
      )}
      {step === 3 && (
        <Step3
          nomsParticipants={nomsParticipants}
          nomsTournees={nomsTournees}
          nbrEnTournee={nbrEnTournee}
          setStep={setStep}
        />
      )}
    </div>
  );
}

function Step1({
  setStep,
  nbrParticipants,
  setNbrParticipants,
  nbrEnTournee,
  setNbrEnTournee
}) {
  const handleSuivant = () => {
    const pNbrParticipants = parseInt(nbrParticipants, 10)
    const pNbrEnTournee = parseInt(nbrEnTournee, 10)
    if (isNaN(pNbrParticipants) || pNbrParticipants < 2 || pNbrParticipants > 5) {
      alert('Le nombre de participants doit être entre 2 et 5.')
      return
    }
    if (isNaN(pNbrEnTournee) || pNbrEnTournee < 1 || pNbrEnTournee > pNbrParticipants || pNbrEnTournee > 3) {
      alert('Le nombre en tournée doit être au moins 1, inférieur au nombre total de participants et aussi inférieur à 3.')
      return
    } else {
      setNbrParticipants(pNbrParticipants)
      setNbrEnTournee(pNbrEnTournee)
      setStep(2)
    }
  }

  return (
    <div className="card p-4">
      <div className="mb-3">
        <label className="form-label">
          Nombre de participants (2-5) :{' '}
        </label>
        <input
          type="text"
          className="form-control"
          inputMode="numeric"
          pattern="[0-9]*"
          value={nbrParticipants === 0 ? '' : nbrParticipants}
          // onChange={e => setNbrParticipants(Number(e.target.value))}
          onChange={e => {
            // const val = Number(e.target.value)
            const val = e.target.value
            if (/^\d*$/.test(val)) {
              setNbrParticipants(val)
              if (val <= nbrEnTournee) {
                setNbrEnTournee(Math.max(1, val - 1))
              }
            }
            // setNbrParticipants(val)
            // if (val <= nbrEnTournee) {
            //   setNbrEnTournee(Math.max(1, val - 1))
            // }
          }}
        />
      </div>
      <div className="mb-3">
        <label className="form-label">
          Nombre de participants en tournée (1-3) :{' '}
        </label>
        <input
          type="text"
          className="form-control"
          inputMode="umeric"
          pattern="[0-9]*"
          value={nbrEnTournee === 0 ? '' : nbrEnTournee}
          onChange={e => {
            const val = e.target.value
            if (/^\d*/.test(val)) {
              setNbrEnTournee(val)
            }  
            }
          }
        />
      </div>
      <button className="btn btn-primary mt-3" onClick={handleSuivant}>Suivant</button>
    </div>
  )
}

function Step2({
  setStep,
  nbrParticipants,
  nbrEnTournee,
  nomsParticipants,
  setNomsParticipants,
  nomsTournees,
  setNomsTournees
}) {
  // const [localNoms, setLocalNoms] = useState(Array(nbrParticipants).fill(''))
  // const [localTournee, setLocalTournee] = useState(Array(nbrEnTournee).fill(''))
  const [localNoms, setLocalNoms] = useState([])
  const [localTournee, setLocalTournee] = useState([])

  useEffect(() => {
    if (nomsParticipants.length === 0) {
      setLocalNoms(Array(nbrParticipants).fill(''))
    } else {
      const noms = [...nomsParticipants]
      while (noms.length < nbrParticipants) {
        noms.push('')
      }
      setLocalNoms(noms.slice(0, nbrParticipants))
    }
    if (nomsTournees.length === 0) {
      setLocalTournee(Array(nbrEnTournee).fill(''))
    } else {
      const tournees = [...nomsTournees]
      while (tournees.length < nbrEnTournee) {
        tournees.push('')
      }
      setLocalTournee(tournees.slice(0, nbrEnTournee))
    }
  }, [nomsParticipants,nomsTournees,nbrParticipants,nbrEnTournee])

  const handleStart = () => {
    if (localNoms.some(n => n.trim() === '') || localTournee.some(t => t.trim() === '')) {
      alert('Veuillez remplir tous les noms ...')
      return
    }
    setNomsParticipants(localNoms)
    setNomsTournees(localTournee)
    setStep(3)
  }

  return (
    <div className="card p-4">
      <h2 className="mb-4">Entrer les noms des participants</h2>
      {localNoms.map((nom, index) => (
        <div className="mb-3" key={index}>
          <label className="form-label">
            Participant {index + 1} :{' '}
          </label>
          <input
            type="text"
            className="form-control"
            value={nom}
            onChange={e => {
              const copie = [...localNoms]
              copie[index] = e.target.value
              setLocalNoms(copie)
            }}
          />
        </div>
      ))}
      <h2 className="mb-4 mt-5">Entrer les noms des tournées</h2>
      {localTournee.map((tournee, index) => (
        <div className="mb-3" key={index}>
          <label className="form-label">
            Tournée {index + 1} : {' '}
          </label>
          <input
            type="text"
            className="form-control"
            value={tournee}
            onChange={e => {
              const copie = [...localTournee]
              copie[index] = e.target.value
              setLocalTournee(copie)
            }}
          />
        </div>
      ))}
      <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-success" onClick={handleStart} style={{marginRight:'10px'}}>Lancer le jeu</button>
        <button className="btn btn-danger" onClick={() => setStep(1)}>Retour au début</button>
      </div>
    </div>
  )
}

function Step3({
  nomsParticipants,
  nomsTournees,
  nbrEnTournee,
  setStep
}) {
  const [resultats, setResultats] = useState([])
  useEffect(()=>{
    const melangePatricipants = [...nomsParticipants].sort(() => 0.5 - Math.random())
    const partants = melangePatricipants.slice(0, nbrEnTournee)
    const auCentre = melangePatricipants.slice(nbrEnTournee)
    const melangeTournees = [...nomsTournees].sort(()=>0.5 - Math.random())
    
    const res = []

    partants.forEach((participant, index) => {
      res.push({
        nom: participant,
        role: 'En tournée',
        tournee: melangeTournees[index]
      })
    })

    auCentre.forEach((participant => {
      res.push({
        nom: participant,
        role: 'Centre de contrôle',
        tournee: null
      })
    }))

    setResultats(res)

  }, [nomsParticipants, nomsTournees, nbrEnTournee])

  return (
    <div className="card p-4">
      <h2 className="mb-4 text-center">Les résultats</h2>
      <ul className="list-group mb-4">
        {resultats.map((r, index) => (
          <li 
            key={index}
            className={`list-group-item d-flex justify-content-between align-items-center ${
              r.role === 'En tournée' ? 'list-group-item-success' : 'list-group-item-light'
            }`}
          >
            <strong>{r.nom}</strong>
            {r.role === 'En tournée' ? (
              <>
                <span>En tournée</span>
                <span className="badge bg-success rounded-pill">{r.tournee}</span>
              </>
            ) : (
              <span>Reste au centre de contrôle</span>
            )}
          </li>
        ))}
      </ul>

      <div className="d-flex justify-content-between">
        <button className="btn btn-success" onClick={() => setStep(2)} style={{marginRight:'10px'}}>
          Modifier noms / tournées
        </button>
        <button className="btn btn-danger" onClick={() => setStep(1)}>
          Recommencer depuis le début
        </button>
      </div>
    </div>
  )
}

export default App2;
